module.exports = __webpack_public_path__ + "static/media/logoQI.e8a52c63.png";